import ListMembersRequest from "./ListMembersRequest"

class ListAttachableMembersRequest  extends ListMembersRequest {}

export default ListAttachableMembersRequest